import { UIComponentCSSStyleImpl, UIComponentCSSStyle } from '../../uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';

export interface EnglishArtistRowCSSStyle extends UIComponentCSSStyle
{
   getToneImageDivCSSStyle():object;
   getToneImageCSSStyle():object;
   getContentDivCSSStle():object;
   getArtistNameCSSStyle():object;
   getActionDivCSSStyle():object;
   getActionImageCSSStyle():object;
}

export class  EnglishArtistRowCSSStyleImpl extends UIComponentCSSStyleImpl implements EnglishArtistRowCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            borderRadius:'8px',
            marginTop:'20px',
            height:'80px',
            display:'flex',
             flexDirection:'row',
             backgroundColor:this.getResources().getColor(Colors.color_5), 
             boxShadow: "0 2px 10px 0 rgba(0,0,0,0.07)",
             flexFlow: "row wrap",
           
        };
    }
    getToneImageDivCSSStyle():object
    {
        return{
            flex:'0.063',
            height:'80px',
        };
    }
    
    getToneImageCSSStyle():object
    {
        return{
            flex:'0.063',
            height:'80px',
            borderRadius:'8px 0px 0px 8px'
        };
    }
    getContentDivCSSStle(): object 
    {
        return{
            // width:'500px',
            minWidth:"70px",
            flex:'0.5',
            height:'30px',
        };
    }
   
    getArtistNameCSSStyle(): object
     {
         return{
            minWidth:'60px',fontFamily: this.getResources().getFontFamily(),
            margin:'26px 20px 24px 20px',
            flex:'0.5',
            letterSpacing:'0', height:'30px',lineHeight:'30px',
            fontSize:this.getResources().getFont(Fonts.h8),
            color:this.getResources().getColor(Colors.color_6),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
         };
    }
    getActionDivCSSStyle(): object 
    {
        return{
            // width:'79px',
            flex:'0.05',
            height:'100%',
            marginLeft:'auto',
            borderLeft:'1px solid'+this.getResources().getColor(Colors.color_3),
            cursor:'pointer'
        
        };
    }
    getActionImageCSSStyle(): object {
        return{
            margin:'35px 20px 34.33px 22px',
            backgroundColor:this.getResources().getColor(Colors.color_5)
        };
    }
    

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/artist/englishartistrowcss.tsx